import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import translationsEN from "./locales/en/resources.json";
import translationsES from "./locales/es/resources.json";
import translationsDE from "./locales/de/resources.json";
import translationsFR from "./locales/fr/resources.json";
import translationsJA from "./locales/ja/resources.json";

const resources = {
  en: {
    translation: translationsEN
  },
  de: {
    translation: translationsDE
  },
  es: {
    translation: translationsES
  },
  fr: {
    translation: translationsFR
  },
  ja:{
    translation: translationsJA
  }
};

const detectionOptions = {
  order: ['querystring', 'cookie', 'navigator'],
  
  // Keys for looking up over predefined language settings
  lookupQuerystring: 'culture',
  lookupCookie: '.AspNetCore.Culture',

  caches: ['cookie']
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    whitelist: ["de", "en", "es", "fr", "ja"],
    fallbackLng: "en",
    detection: detectionOptions,
    keySeparator: '::'
  });

export default i18n;
